module.exports = __webpack_public_path__ + "static/media/fnb.e84c9960.svg";